import { useMemo } from 'react'
import type { EntityIndex } from '../../hooks/use-entity-index'

/**
 * Auto-complete hook for schema field name input.
 * Returns matching variable names from EntityIndex when input has 2+ chars.
 * Adapted from useSymbolSuggestions (expression-form.tsx) per D-08, D-09.
 */
export function useFieldSuggestions(
  inputValue: string,
  entityIndex: EntityIndex | undefined,
): string[] | null {
  const variableNames = useMemo(() => {
    if (!entityIndex?.variables) return []
    return entityIndex.variables.map((v) => v.name)
  }, [entityIndex?.variables])

  return useMemo(() => {
    if (!inputValue || inputValue.length < 2) return null
    const lower = inputValue.toLowerCase()
    const matches = variableNames.filter((n) =>
      n.toLowerCase().startsWith(lower),
    )
    return matches.length > 0 ? matches : null
  }, [inputValue, variableNames])
}
